import { Chip } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "i18n-fe";

// #3277 -- the "Needs placings" indicator (#340) is a real link into that
// class's placing form: ClassPlacings reads ?classId= on mount (#1069), so an
// admin lands with the class already selected instead of finding it again in
// the picker. MUI Chip with component=RouterLink renders a real <a href>, so
// it is keyboard reachable (Tab, Enter) and cmd-click-able. stopPropagation
// keeps a click on the row's chip from also firing the row's own onClick
// (which opens the class detail drawer). No class id -> plain, unlinked chip.
export default function NeedsPlacingsChip({ classId, sx, ...chipProps }) {
  const { t } = useTranslation("scoreadmin");
  const label = t("ring.needsPlacingsBadge");
  if (!classId) {
    return <Chip size="small" color="warning" label={label} sx={sx} {...chipProps} />;
  }
  return (
    <Chip
      size="small"
      color="warning"
      label={label}
      component={RouterLink}
      to={`/placings?classId=${encodeURIComponent(classId)}`}
      clickable
      onClick={(e) => e.stopPropagation()}
      sx={sx}
      {...chipProps}
    />
  );
}
